import { render, staticRenderFns } from "./SSLatestBlogPost.vue?vue&type=template&id=6fc30dd4&scoped=true&"
import script from "./SSLatestBlogPost.vue?vue&type=script&lang=js&"
export * from "./SSLatestBlogPost.vue?vue&type=script&lang=js&"
import style0 from "./SSLatestBlogPost.vue?vue&type=style&index=0&id=6fc30dd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc30dd4",
  null
  
)

export default component.exports